import { FC, useState } from "react";
import { Drawer, Layout, Menu } from "antd";
import {
  BarcodeOutlined,
  CarOutlined,
  CommentOutlined,
  ContactsOutlined,
  DollarOutlined,
  FileImageOutlined,
  FileTextOutlined,
  HomeOutlined,
  MenuOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./layout-app.less";
import { Link, useLocation } from "react-router-dom";
import HeaderApp from "./header-app";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "app.store";
import SubMenu from "antd/lib/menu/SubMenu";
import EmptyBranch from "shared/components/empty-branch/empty-branch";
import {
  COMMENT_ROUTE,
  FIREBASE_CONFIG_ROUTE,
  ORDER_REPORT_ROUTE,
  ORDER_ROUTE,
  PAYMENT_SETTING_ROUTE,
  PRODUCT_ATTRIBUTE_GROUP_ROUTE,
  PRODUCT_ATTRIBUTE_ROUTE,
  PRODUCT_ATTRIBUTE_VALUE_ROUTE,
  PRODUCT_CATEGORY_ROUTE,
  PRODUCT_COMMENT_ROUTE,
  PRODUCT_ROUTE,
  PROMOTION_CODE_ROUTE,
  SHIPPING_FEE_DEFAULT_ROUTE,
  STAFF_ROUTE,
  SYSTEM_CONFIG_ROUTE,
  TAG_ROUTE,
  THEME_SETTING_ROUTE,
  THEME_TEMPLATE_ROUTE,
  TRANSPORTATION_ROUTE,
  UNIT_ROUTE,
  WEBSITE_CONFIG_ROUTE,
} from "shared/constants/routes";
import {
  CurrentUser,
  isAdmin,
  isHavePermission,
} from "states/account/account.models";
import { PermissionNameEnum } from "states/role-management/role-management.models";
import { isDesktop } from "react-device-detect";

const { Content, Sider } = Layout;

type LayoutAppProps = any;

const LayoutApp: FC<LayoutAppProps> = (props) => {
  const unSelectBranchPath = ["/admin/branch"];

  const [visible, setVisible] = useState(false);
  const onToggleDrawer = () => {
    setVisible(!visible);
  };
  const location = useLocation();
  const isLogin = useSelector(
    (state: RootState) => state.account.isAuthentication,
    shallowEqual
  );
  const currentUser = useSelector(
    (state: RootState) => state.account.currentUser,
    shallowEqual
  );
  const currentBranch = useSelector(
    (state: RootState) => state.branch.currentBranch,
    shallowEqual
  );

  return isLogin ? (
    <Layout hasSider={true} className="layout-page">
      {!isDesktop ? (
        <Drawer
          forceRender
          title={false}
          placement="left"
          closable={true}
          closeIcon={false}
          visible={visible}
        >
          <div className="z">
            <SiderMenu isMobile={!isDesktop} currentUser={currentUser} />
          </div>
          <div className="drawer-handle" onClick={onToggleDrawer}>
            <div className="drawer-icon-handle">
              <MenuOutlined />
            </div>
          </div>
        </Drawer>
      ) : (
        <SiderMenu currentUser={currentUser} />
      )}

      <Layout className={`drawer-menu ${visible ? `drawer-menu-active` : ``}`}>
        <HeaderApp />
        <Content className="layout-content">
          {currentBranch.id ||
          unSelectBranchPath.filter(
            (m) =>
              location.pathname === m ||
              location.pathname.startsWith(m + "/add") ||
              location.pathname.startsWith(m + "/update")
          ).length > 0 ? (
            props.children
          ) : (
            <EmptyBranch />
          )}
        </Content>
      </Layout>
    </Layout>
  ) : null;
};
interface ISiderMenu {
  currentUser?: CurrentUser;
  isMobile?: boolean;
}
const SiderMenu: FC<ISiderMenu> = (props) => {
  const { currentUser, isMobile } = props;
  const [menuCollapse, setMenuCollapse] = useState(false);
  return (
    <Sider
      width={!isMobile ? `230px` : ``}
      className="main-sider"
      collapsible
      collapsed={menuCollapse}
      onCollapse={(collapsed) => {
        setMenuCollapse(collapsed);
      }}
    >
      <div className="logo">
        <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="" />
      </div>
      <Menu className="nav" mode="inline">
        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(currentUser, PermissionNameEnum.OrderManage)) && (
            <Menu.Item key="dashboard" icon={<HomeOutlined />}>
              <Link to={ORDER_REPORT_ROUTE}>Bảng điều khiển</Link>
            </Menu.Item>
          )}
        <SubMenu key="order" icon={<DollarOutlined />} title="Bán hàng">
          {currentUser && (
            <>
              <Menu.Item>
                <Link to={ORDER_ROUTE}>Đơn hàng</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={PROMOTION_CODE_ROUTE}>Mã khuyến mãi</Link>
              </Menu.Item>
            </>
          )}
        </SubMenu>

        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(
              currentUser,
              PermissionNameEnum.ProductManage
            )) && (
            <SubMenu key="product" icon={<BarcodeOutlined />} title="Sản phẩm">
              <Menu.Item>
                <Link to={PRODUCT_ROUTE}>Sản phẩm</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={PRODUCT_CATEGORY_ROUTE}>Danh mục sản phẩm</Link>
              </Menu.Item>
              {/* <Menu.Item>
             <Link to={MODIFIER_GROUP_ROUTE}>Modifier groups</Link>
           </Menu.Item> */}
              <Menu.Item>
                <Link to={UNIT_ROUTE}>Đơn vị</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={PRODUCT_ATTRIBUTE_GROUP_ROUTE}>Nhóm thuộc tính</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={PRODUCT_ATTRIBUTE_ROUTE}>Thuộc tính</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={PRODUCT_ATTRIBUTE_VALUE_ROUTE}>
                  Giá trị thuộc tính
                </Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={TAG_ROUTE}>Tags</Link>
              </Menu.Item>
            </SubMenu>
          )}

        {/* <SubMenu key="ton-kho" icon={<ShopOutlined />} title="Inventories">
       <Menu.Item>
         <Link to={PRODUCT_STOCK_ROUTE}>Danh sách tồn kho</Link>
       </Menu.Item>
       <Menu.Item>
         <Link to={PURCHASE_ROUTE}>Nhập hàng</Link>
       </Menu.Item>
       <Menu.Item>
         <Link to={SUPPLIER_ROUTE}>Nhà cung cấp</Link>
       </Menu.Item>
       <Menu.Item>
         <Link to={WARE_HOUSE_ROUTE}>Warehouses</Link>
       </Menu.Item>
     </SubMenu> */}

        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(
              currentUser,
              PermissionNameEnum.CustomerManage
            )) && (
            <SubMenu
              key="customer"
              icon={<ContactsOutlined />}
              title="Khách hàng"
            >
              <Menu.Item>
                <Link to="/admin/customers">Danh sách khách hàng</Link>
              </Menu.Item>
              <Menu.Item key="contact">
                <Link to="/admin/contact">Liên hệ</Link>
              </Menu.Item>
            </SubMenu>
          )}
        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(
              currentUser,
              PermissionNameEnum.CommentManage
            )) && (
            <>
              <Menu.Item key="comment" icon={<CommentOutlined />}>
                <Link to={COMMENT_ROUTE}>Bình luận</Link>
              </Menu.Item>
            </>
          )}
        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(
              currentUser,
              PermissionNameEnum.WebsiteContentManage
            )) && (
            <>
              <SubMenu
                icon={<FileTextOutlined />}
                key="blogsub"
                title={`Bài viết`}
              >
                <Menu.Item>
                  <Link to="/admin/blog">Danh sách bài viết</Link>
                </Menu.Item>
                <Menu.Item>
                  <Link to="/admin/blog-category">Danh mục bài viết</Link>
                </Menu.Item>
              </SubMenu>
              <Menu.Item key="static-page" icon={<FileTextOutlined />}>
                <Link to="/admin/static-page">Trang tĩnh</Link>
              </Menu.Item>
            </>
          )}
        {/* {currentUser &&
       (isAdmin(currentUser) ||
         isHavePermission(
           currentUser,
           PermissionNameEnum.BranchManage
         )) && (
         <Menu.Item key="branch-setting" icon={<BranchesOutlined />}>
           <Link to={BRANCH_ROUTE}>Chi nhánh</Link>
         </Menu.Item>
       )} */}
        <Menu.Divider />
        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(currentUser, PermissionNameEnum.OrderManage)) && (
            <SubMenu key="van-chuyen" title="Vận chuyển" icon={<CarOutlined />}>
              <Menu.Item>
                <Link to={SHIPPING_FEE_DEFAULT_ROUTE}>Cấu hình phí ship</Link>
              </Menu.Item>
              <Menu.Item>
                <Link to={TRANSPORTATION_ROUTE}>Nhà vận chuyển</Link>
              </Menu.Item>
            </SubMenu>
          )}
        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(currentUser, PermissionNameEnum.OrderManage)) && (
            <Menu.Item
              key="thanh-toan"
              title="Thanh toán"
              icon={<DollarOutlined />}
            >
              <Link to={PAYMENT_SETTING_ROUTE}>Cấu hình thanh toán</Link>
            </Menu.Item>
          )}
        <SubMenu key="configsub" icon={<SettingOutlined />} title="Cấu hình">
          {currentUser &&
            (isAdmin(currentUser) ||
              isHavePermission(
                currentUser,
                PermissionNameEnum.WebsiteContentManage
              )) && (
              <>
                <Menu.Item key="theme-setting">
                  <Link to={THEME_SETTING_ROUTE}>Giao diện</Link>
                </Menu.Item>
                <Menu.Item key="menu-setting">
                  <Link to="/admin/menu-setting">Menu</Link>
                </Menu.Item>
              </>
            )}
          {currentUser && isAdmin(currentUser) && (
            <>
              <Menu.Item key="website-config">
                <Link to={WEBSITE_CONFIG_ROUTE}>Cấu hình website</Link>
              </Menu.Item>
              <Menu.Item key="theme-template">
                <Link to={THEME_TEMPLATE_ROUTE}>Mẫu giao diện</Link>
              </Menu.Item>

              <Menu.Item key="system-config">
                <Link to={SYSTEM_CONFIG_ROUTE}>Hệ thống</Link>
              </Menu.Item>
              <Menu.Item key="firebase-config">
                <Link to={FIREBASE_CONFIG_ROUTE}>Cấu hình firebase</Link>
              </Menu.Item>
            </>
          )}
        </SubMenu>

        {currentUser &&
          (isAdmin(currentUser) ||
            isHavePermission(currentUser, PermissionNameEnum.StaffManage)) && (
            <SubMenu key="usersub" icon={<UserOutlined />} title="Nhân viên">
              <Menu.Item key="staff">
                <Link to={STAFF_ROUTE}>Nhân viên</Link>
              </Menu.Item>
              <Menu.Item key="role-management">
                <Link to="/admin/role-management">Phân quyền</Link>
              </Menu.Item>
            </SubMenu>
          )}
      </Menu>
    </Sider>
  );
};
export default LayoutApp;
